module.exports = __webpack_public_path__ + "img/metrics.72ef35fb.png";